import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


@Component({
    templateUrl: './coupon-preview-modal.component.html',
    styleUrls: ['./coupon-preview-modal.component.css', 'coupon-form.component.css']
  })

export class CouponPreviewModalComponent implements OnInit{
    public uploadLogoFocus: boolean
    public expirationDateFocus: boolean
    public form: FormGroup;
    public imgUrl: string;

    public previewMode = 'Apple';

    constructor(
        private fb: FormBuilder,
        private viewRef: ViewContainerRef,
        private modalService: BsModalService,
        private bsModalRef: BsModalRef,
    ){}

    ngOnInit(){

    }
    close() {
        this.bsModalRef.hide();
    }
}
